// extracted by mini-css-extract-plugin
module.exports = {"AppStyle":"style_AppStyle__2XWlM"};